export const tags = [
  {
    tag: '<',
    el: '#[188]',
  },
  {
    tag: '>',
    el: '#[190]',
  },
  {
    tag: '/>',
    el: '#[191|190]',
  },
  {
    tag: '<a href="',
    el: '#[link1]',
  },
  {
    tag: '" target="_blank" rel="noreferrer">',
    el: '#[link2]',
  },
  {
    tag: '</a>',
    el: '#[link3]',
  },
];
